<template>
  <div :class="['container', size]">
    <div class="label-ct">
      <span class="label"> {{ labelText }} </span>
      <el-tooltip v-if="infoIcon" :placement="tooltipPlacement">
        <div
          style="text-align: center"
          slot="content"
          v-html="tooltipContent"
        />
        <span><i class="el-icon-warning-outline"></i></span>
      </el-tooltip>
      <p v-if="descriptionText" class="description">
        {{ descriptionText }}
      </p>
    </div>
    <el-tooltip
      :disabled="!disabled"
      placement="right"
      :content="disabledReasonTooltip"
    >
      <el-switch :disabled="disabled" v-model="switchValue" />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'LabelDescriptionToggle',
  props: {
    labelText: {
      type: String,
      required: true
    },
    descriptionText: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'small',
      required: false
    },
    infoIcon: {
      type: Boolean,
      default: false,
      required: false
    },
    tooltipContent: {
      type: String
    },
    tooltipPlacement: {
      type: String,
      default: 'right'
    },
    value: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledReasonTooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchValue: {
      get() {
        return this.value
      },

      set(switchValue) {
        this.$emit('change', switchValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  &.small {
    column-gap: 80px;
  }
  &.medium {
    column-gap: 120px;
  }
}
.label-ct {
  width: 170px;
}
.label {
  font-size: 14px;
  color: #5c6374;
}

.description {
  font-size: 12px;
  color: #7e8596;
}

.el-switch {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/LabelDescriptionToggle.vue